/* eslint-disable import/prefer-default-export */
import { USA_AND_TERRITORIES } from '@airtm/utils/dist/constants';
import { PARTNER } from '@airtm/utils/dist/constants/userRoles';
import { Auth__User } from 'types/__generated__/graphql-global-types';

export const resolvers = {
  Auth__User: {
    canUseP2P: (root: Auth__User): boolean => !USA_AND_TERRITORIES.includes(root?.country ?? ''),

    isPartner: (root: Auth__User): boolean => !!root?.roles?.includes(PARTNER),
  },
};
